export type Bonus = {
  number: string
  title: string
  /** Short title printed on the code-drawn cover. */
  short: string
  body: string
  accent: string
  /** Optional rendered cover. When empty, a code-drawn cover is shown. */
  cover?: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Find Your Starting Point: The Rec Group Placement Guide',
    short: 'Find Your Starting Point',
    body: 'Answer three quick questions about your group’s age and what they can already do, and this guide points you to the exact volume and week to start — plus how to run it when your class spans two levels at once.',
    accent: 'bg-coral',
  },
  {
    number: '02',
    title: 'Say It So They Get It: The Kid-Friendly Cue Script',
    short: 'Say It So They Get It',
    body: 'The exact playful words and metaphors to say so 3-to-8-year-olds understand a shape or skill the first time — “stand like a pencil, squash like a pancake” — plus the attention-reset lines that pull a wandering group back.',
    accent: 'bg-indigo',
  },
  {
    number: '03',
    title: 'No Gym, No Problem: The Minimal-Equipment Adaptation Cheat Sheet',
    short: 'No Gym, No Problem',
    body: 'One cheat sheet that swaps every apparatus skill in the year for a mats-only or small-space version — so you can run the whole Class-Ready year in a school hall, a church gym or a corner of a sports centre.',
    accent: 'bg-teal',
  },
  {
    number: '04',
    title: 'Covered: The Last-Minute Cover-Class Pack',
    short: 'Covered',
    body: 'Four grab-and-go classes you can teach cold — any age, any level — when you’re covering for a colleague at the last minute with zero prep. Includes a 2-minute “read the room” opener.',
    accent: 'bg-amber',
  },
  {
    number: '05',
    title: 'Press Play: The Rec Gymnastics Music & Timing Guide',
    short: 'Press Play',
    body: 'BPM ranges for every phase of class and for floor routines, where to find royalty-free music, and 8-count timing templates so your routines actually fit the music.',
    accent: 'bg-coral',
  },
]
